import React from "react";
import LandingLayout from "../../components/LandingLayout";

const Login = () => {
  return <LandingLayout>Login</LandingLayout>;
};

export default Login;
